export const AUTO_HIDE_DURATION_IN_MS = 5_000
